import CityPageTemplate from "../city-template/CityPageTemplate";
import { fayettevilleConfig } from "./data";

export default function FayettevillePage() {
  return <CityPageTemplate config={fayettevilleConfig} />;
}